import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSidebarIconContacts = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "contacts",
	viewBox: "-232 385.9 70 70",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M-164.9,448c0-3.3-2.9-5.3-11.5-7.5c-4.5-1.1-8.2-3.7-8.2-3.7c-0.6-0.3-0.1-3.2-0.1-3.2l-3.2-0.5c0-0.2-0.2-3.7-0.2-3.7 c3.3-1.1,3-7.6,3-7.6c2.1,1.2,3.5-4,3.5-4c2.5-7.2-1.2-6.7-1.2-6.7c1.2-5.4,0-13.2,0-13.2c-1.7-14.5-27.2-10-23.4-5.4 c-9.1-2.5-5.9,14.7-5.9,14.7l1.6,4.3c-3.1,2-0.9,4.4-0.8,7.2c0.2,4.1,2.7,3.3,2.7,3.3c0.2,6.8,3.5,7.7,3.5,7.7 c0.6,4.3,0,3.9,0,3.9l-3.9,0.3c0,0,0.3,2.6-0.3,3c0,0-3.8,2.6-8.2,3.7c-8.6,2.2-11.5,4.2-11.5,7.5c0,0-0.9,0.4-0.9,5.8h66 C-164,448.5-164.9,448-164.9,448z" })
});
export default SvgSidebarIconContacts;
